module.exports = __webpack_public_path__ + "media/images/flags/bt-ef7444a31a76d54b22af8dc1609e891c.svg";